import { takeEvery, select, call } from '@redux-saga/core/effects';
import { LOCATION_CHANGE } from 'react-router-redux';
import Auth from '@aws-amplify/auth';
import Cookies from '../../../utils/Cookies';
import { setAuthenticatedCookies } from '../../utils/cookies';
import { getRedirectPath } from '../../utils/redirect';
import { getQueryParams, isLoggedIn } from '../../utils/selectors';
import { COOKIES, ROUTES } from '../../../constants';

export function* setCookiesIfNotPresent() {
  const loggedIn = yield select(isLoggedIn);
  if (loggedIn && !Cookies.get(COOKIES.COGNITO_JWT)) {
    const { accessToken } = yield call([Auth, 'currentSession']);
    setAuthenticatedCookies(accessToken.jwtToken);
  }
}

export function* checkProtectedRoutes(action) {
  const { pathname } = action.payload;
  const { SIGN_OUT, REGISTER, SIGN_IN, SOCIAL_AUTH_REDIRECT, MARKETING_PREFERENCES } = ROUTES;
  if ([SIGN_OUT, SOCIAL_AUTH_REDIRECT].includes(pathname)) return;

  yield call(setCookiesIfNotPresent);
  const loggedIn = yield select(isLoggedIn);
  switch (action.payload.pathname) {
    case REGISTER:
    case SIGN_IN: {
      if (loggedIn) {
        const queryParams = yield select(getQueryParams);
        window.location = `//${window.location.host}${getRedirectPath(queryParams)}`;
      }
      break;
    }
    case MARKETING_PREFERENCES: {
      if (!loggedIn) {
        window.location = `${SIGN_IN}?redirect_url=${encodeURIComponent(action.payload.pathname)}`;
      }
      break;
    }
    default:
  }
}

export function* routingSaga() {
  yield takeEvery(LOCATION_CHANGE, checkProtectedRoutes);
}

export default routingSaga;
